import React, {useState} from 'react';
import './AdminPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import FloatingBackButton from '../../elements/FloatingBackButton/FloatingBackButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {downloadReplaysArchive, REPLAYS_ARCHIVE_KINDS} from '../../../utils/admin/downloadReplaysArchive';

const PAGE_ID = 'AdminPage';

function AdminPage({
                     onUsersList,
                     onDeleteUser,
                     onMatchesList,
                     onPurchasesList,
                     onChestOpeningsList,
                     onDailyLoginRewardsList,
                     onRatingCrystalsList,
                     onCreateRankedLobby,
                     onPartnersList,
                     onFriendReferalConfig,
                     onLoginPromo,
                     onModalsTest,
                     onGameUiKit,
                     onBack,
                   }) {
  usePageAnalytics('AdminPage');
  // Какой архив сейчас собирается (null — никакой)
  const [exportingArchiveKind, setExportingArchiveKind] = useState(null);

  // Архив записей всех матчей (или прохождений обучения) для офлайн-анализа.
  // Сервер собирает его на лету, на проде это может занять заметное время —
  // кнопки на это время блокируются: сервер собирает один архив за раз
  const handleDownloadReplaysArchive = async (kind) => {
    if (exportingArchiveKind) return;

    setExportingArchiveKind(kind);
    try {
      await downloadReplaysArchive({kind});
    } catch (e) {
      console.error('[AdminPage] replays archive error', e);
      alert(e.message || 'Не удалось собрать архив реплеев');
    } finally {
      setExportingArchiveKind(null);
    }
  };

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={PAGE_ID}/>

      <h1 className="lobby-page-title">Админка</h1>

      <div className="admin-page-buttons">
        <PageButton onClick={onUsersList} pageId={PAGE_ID} buttonId="users_list">
          Список пользователей
        </PageButton>
        <PageButton onClick={onMatchesList} pageId={PAGE_ID} buttonId="matches_list">
          Список матчей
        </PageButton>
        <PageButton
          onClick={() => handleDownloadReplaysArchive(REPLAYS_ARCHIVE_KINDS.NETWORK)}
          pageId={PAGE_ID}
          buttonId="replays_archive"
          disabled={Boolean(exportingArchiveKind)}
        >
          {exportingArchiveKind === REPLAYS_ARCHIVE_KINDS.NETWORK ? 'Собираем архив реплеев…' : 'Архив всех реплеев'}
        </PageButton>
        <PageButton
          onClick={() => handleDownloadReplaysArchive(REPLAYS_ARCHIVE_KINDS.TUTORIAL)}
          pageId={PAGE_ID}
          buttonId="tutorial_replays_archive"
          disabled={Boolean(exportingArchiveKind)}
        >
          {exportingArchiveKind === REPLAYS_ARCHIVE_KINDS.TUTORIAL ? 'Собираем архив обучения…' : 'Архив записей обучения'}
        </PageButton>
        <PageButton onClick={onDailyLoginRewardsList} pageId={PAGE_ID} buttonId="daily_login_rewards_list">
          История ежедневных наград
        </PageButton>
        <PageButton
          className={'admin-page_primary-button'} onClick={onPartnersList} pageId={PAGE_ID} buttonId="partners_list"
        >
          Партнеры
        </PageButton>
        <PageButton
          className={'admin-page_primary-button'} onClick={onFriendReferalConfig} pageId={PAGE_ID}
          buttonId="friend_referal_config"
        >
          Приглашение друзей
        </PageButton>
        <PageButton
          className={'admin-page_primary-button'} onClick={onLoginPromo} pageId={PAGE_ID} buttonId="login_promo"
        >
          Акция за вход
        </PageButton>
        <PageButton onClick={onPurchasesList} pageId={PAGE_ID} buttonId="purchases_list">
          История покупок
        </PageButton>
        <PageButton onClick={onChestOpeningsList} pageId={PAGE_ID} buttonId="chest_openings_list">
          История открытий сундуков
        </PageButton>
        <PageButton onClick={onRatingCrystalsList} pageId={PAGE_ID} buttonId="rating_crystals_list">
          Кристаллы за рейтинг
        </PageButton>
        <PageButton
          className={'admin-page_attention-button'} onClick={onCreateRankedLobby} pageId={PAGE_ID}
          buttonId="create_ranked_lobby"
        >
          Создать рейтинговое лобби
        </PageButton>
        <PageButton onClick={onModalsTest} pageId={PAGE_ID} buttonId="modals_test">
          Тест модалок
        </PageButton>
        <PageButton onClick={onGameUiKit} pageId={PAGE_ID} buttonId="game_ui_kit">
          Витрина интерфейса матча
        </PageButton>
        <PageButton
          className={'admin-page_tertiary-color'} onClick={onDeleteUser} pageId={PAGE_ID} buttonId="delete_user"
        >
          Удалить пользователя
        </PageButton>
      </div>

      <div className="main-menu-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default AdminPage;
